export default __webpack_public_path__ + "images/7f4cd4768e6f763b91c98a12b9dadb6e.svg";